<template>
  <View gap="sm">
    <slot />
  </View>
</template>

<script setup lang="ts">
import View from '../view/view.vue';
</script>

<style scoped></style>
